import axios from "../../axios";

const getSoldInventoryByCustomer = async (customer_id) => {
  try {
    const { data } = await axios.get(`/inventory?status[$eq]=sold&customer_id[$eq]=${customer_id}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getInventoryHistory = async (inventory_id) => {
  try {
    const { data } = await axios.get(`/inventory/timeline/${inventory_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const getInventoryAccounting = async (inventory_id) => {
  try {
    const { data } = await axios.get(`/inventory/accounting/${inventory_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const findDuplicateByID = async (wig_id, brand_name) => {
  wig_id = wig_id?.toUpperCase();
  try {
    const { data } = await axios.get(`/inventory?wig_id[$eq]=${wig_id}&brand_name[$eq]=${encodeURIComponent(brand_name)}&status[$ne]=removed`);
    console.log(data?.rows, "data");
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const updateWigId = async (id, newWigId) => {
  console.log(id, newWigId);
  try {
    const { data } = await axios.put(`/inventory/${id}/wig_id`, {wig_id: newWigId});
    return data;
  } catch (e) {
    throw e;
  }
};

export {
  getSoldInventoryByCustomer,
  getInventoryHistory,
  getInventoryAccounting,
  findDuplicateByID,
  updateWigId
}